import {getNames} from "country-list";

export const COUNTRIES = getNames().sort();

export const COUNTRY_OPTIONS = COUNTRIES.map((country) => ({
    id: country,
    label: country,
}));
